const moment = require("moment");
import VerbConstants from "motw_core/Constants/VerbConstants";
import { IDataProvider } from "../Data/IDataProvider";
import { ILogEntry, resourceNameLogEntry } from "../Entity/ILogEntry";
import { GetEntryPrefix, SaveLogEntryAsync } from "./LogEntryRepository";

const LogRepository = () => {
    async function AddOneTimeLogEntryAsync(
        logEntryVerb: string,
        logEntryName: string,
        dataProvider: IDataProvider,
        OnError?: Function,
        OnFinish?: Function
    ) {
        const entrySymbol = VerbConstants.GetSymbol(logEntryVerb);

        const logEntry: string[] = [
            GetEntryPrefix(0, entrySymbol) +
                " " +
                logEntryVerb +
                " " +
                logEntryName +
                " 1",
            "10",
            "9",
            moment().format("MMM D YYYY HH:mm"),
            "1", // Set energy value to default because its not being used
        ];

        return await SaveLogEntryAsync(
            logEntry,
            dataProvider,
            true,
            OnError,
            OnFinish
        );
    }

    return {
        AddOneTimeLogEntryAsync,
    };
};

export const logRepository = LogRepository();

export async function GetAllLogEntriesAsync(dataProvider: IDataProvider) {
    const result = await dataProvider.GetRecordsAsync<ILogEntry>(
        resourceNameLogEntry
    );
    return result;
}

export async function GetRecentLogEntriesAsync(
    length: number,
    dataProvider: IDataProvider
) {
    const result = await dataProvider.GetRecordsAsync<ILogEntry>(
        `${resourceNameLogEntry}?order=id.desc&limit=${length}`
    );

    return result;
}

export async function DeleteLogEntryAsync(
    id: number,
    dataProvider: IDataProvider
) {
    const result = dataProvider.DeleteRecordsAsync(
        `${resourceNameLogEntry}?id=eq.${id}`
    );

    return result;
}

export async function AddLogEntryAsync(
    newLogEntry: Partial<ILogEntry>,
    dataProvider: IDataProvider
) {
    const result = dataProvider.AddRecordAsync(
        resourceNameLogEntry,
        newLogEntry
    );
    return result;
}

export async function UpdateLogEntryAsync(
    id: number,
    data: ILogEntry,
    dataProvider: IDataProvider
) {
    const result = await dataProvider.UpdateRecordAsync(
        `${resourceNameLogEntry}?id=eq.${id}`,
        data
    );

    return result;
}
